import { render, staticRenderFns } from "./LoginOauth.vue?vue&type=template&id=5fc4873a&"
import script from "./LoginOauth.vue?vue&type=script&lang=js&"
export * from "./LoginOauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports